<template>

    <!-- Start Hero Carousel -->
    <section class="hero is-medium has-carousel" style="height:100vh;">
        <loading :active.sync="isBusy"
                 :can-cancel="false"
                 :is-full-page="true"></loading>
        <div class="hero-carousel">
            <div class="has-background is-active">
                <img class="is-background" src="../assets/sliders/bessac_bg_01_.jpg" alt="" />
            </div>
            <div class="has-background">
                <img class="is-background" src="../assets/sliders/bessac_bg_02_.jpg" alt="" />
            </div>
            <div class="has-background">
                <img class="is-background" src="../assets/sliders/bessac_bg_03_.jpg" alt="" />
            </div>
            <div class="has-background">
                <img class="is-background" src="../assets/sliders/bessac_bg_04_.jpg" alt="" />
            </div>
            <div class="has-background">
                <img class="is-background" src="../assets/sliders/bessac_bg_05_.jpg" alt="" />
            </div>
        </div>
        <div class="hero-body">
            <div class="container">
                <div class="column is-4 is-offset-4">
                    <div class="box padding">
                        <figure class="avatar">
                            <img src="../assets/logo_vertical.svg" alt="Bessac" />
                        </figure>
                        <b-tabs type="is-toggle" expanded position="is-centered" class="block">
                            <b-tab-item label="SSO">
                                <b-button class="is-pulled-right" type="is-success" onclick="window.location.href = 'LoginSSO'">Login</b-button>
                            </b-tab-item>
                            <b-tab-item label="External">
                                <b-field label="Email">
                                    <b-input type="email"
                                             value="john@"
                                             maxlength="30"
                                             v-model="ext.email"
                                             @keyup.native.enter="loginExt"></b-input>
                                </b-field>
                                <b-field label="Password">
                                    <b-input type="password"
                                             value="iwantmytreasure"
                                             password-reveal
                                             v-model="ext.password"
                                             @keyup.native.enter="loginExt"></b-input>
                                </b-field>
                                <b-button class="is-pulled-right" type="is-success" @click="loginExt">Login</b-button>
                            </b-tab-item>
                        </b-tabs>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
    import bulmaCarousel from 'bulma-carousel'
    import Loading from 'vue-loading-overlay';
    import 'vue-loading-overlay/dist/vue-loading.css';

    export default {
        data() {
            return {
                isBusy: false,
                ext: {
                    email: '',
                    password: '',
                },
                sso: {
                    email: '',
                    password: '',
                },
            }
        },
        components:
        {
            Loading
        },
        methods: {
            loginExt() {
                this.isBusy = true;
                try {
                    this.$store
                        .dispatch('retrieveToken', {
                            email: this.ext.email,
                            password: this.ext.password,
                        })
                        .then(genericResponse => {
                            this.isBusy = false;
                            try {
                                if (genericResponse.isError == true) {
                                    this.$buefy.notification.open({
                                        message: genericResponse.messageError,
                                        position: 'is-top',
                                        type: 'is-danger',
                                        hasIcon: true,
                                    });
                                    return;
                                }
                                this.isBusy = true;
                                this.$router.push({ name: 'Jobsite' })

                            } catch (e) {
                                console.error(e.message);
                            }
                        })
                        .catch(error => {
                            this.isBusy = false;
                            try {
                                this.$buefy.notification.open({
                                    message: error.response.data,
                                    position: 'is-top',
                                    type: 'is-danger',
                                    hasIcon: true,
                                });

                            } catch (e) {
                                console.error(e.message);
                            }
                        })
                } catch (e) {
                    this.isBusy = false;
                    console.error(e.message);
                }
            },
        },
        mounted: function () {
            bulmaCarousel.attach('.hero-carousel', {
                slidesToScroll: 1,
                slidesToShow: 1,
                pagination: false,
                navigationKeys: false,
                effect: 'fade',
                autoplay: true,
                loop: true,
            })
        },
    }
</script>

<style scoped>

    .hero.is-fullheight {
        margin: 0 -24px;
    }

    .avatar {
        text-align: center;
    }

        .avatar img {
            height: 100px;
            margin-bottom: 10px;
        }
</style>

